import { action, computed, makeAutoObservable, observable } from "mobx";
import RootStore from "stores/RootStore";

import TenantAPI from "api/tenant";
import UserAPI from "api/user";

export default class TenantStore {
  rootStore: RootStore;
  tenantApi: TenantAPI;
  userApi: UserAPI;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.userApi = new UserAPI({ refreshToken: rootStore.refreshToken });
    this.tenantApi = new TenantAPI({ refreshToken: rootStore.refreshToken });
  }

  @observable initing = true;
  @observable loading = false;
  @observable tenantData = null;

  @action
  getTenants() {
    return new Promise((resolve, reject) => {
      if (this.tenantData) {
        resolve(this.tenantData);
        return;
      }

      this.userApi
        .getTenants()
        .then((res: any) => {
          this.tenantData = res?.tenants ?? [];
          resolve(res?.tenants ?? []);
        })
        .catch((err) => reject(err))
        .finally(() => {
          this.initing = false;
        });
    });
  }

  @action
  getTenant(id) {
    return new Promise((resolve, reject) => {
      this.tenantApi
        .getById(id)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  }

  @action
  getClients(tenantId) {
    return new Promise((resolve, reject) => {
      this.userApi
        .getClients({
          tenantId
        })
        .then((res: any) => resolve(res?.clients ?? []))
        .catch((err) => reject(err));
    });
  }
}
